import React, { useEffect, useState } from "react";
import { GrUserWorker } from "react-icons/gr";
import CMSNavbar from "../Comps/CMS Reports/CMSNavbar";
import CMSBody from "../Comps/CMS Reports/CMSBody";
import CustomHeading from "../Comps/Extra/CustomHeading";
const CMS = () => {
  const [activePage, setActivePage] = useState("Crew Working Hours");
  //   console.log(activePage);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div style={{ minHeight: "90vh" }} className="text-center newUi">
      <CustomHeading
        text={{
          heading: "CMS Dashboard",
          subText: "CMS Dashboard Management System",
        }}
        icon={GrUserWorker}
        style={{
          height: "100px",

          // Main container
          width: "100%",
          borderRadius: "24px",
          shadow: "0 10px 30px rgba(0,0,0,0.15)",
          background: "#fff",

          // Gradient
          gradient: true,
          color: ["#064d87", "#20b8c0", "#087331"],
          gradientDirection: "120deg",

          // Heading
          headingColor: "#ffffff",
          headingSize: "clamp(2rem, 5vw, 3.5rem)",
          headingWidth: "520px",

          // Subtitle
          subtitleColor: "#f4f7fb",
          subtitleSize: "0.95rem",
          subtitleMaxWidth: "650px",
          subtitleLineHeight: 1.5,

          // Content
          contentGap: "4px",
        }}
      />

      <CMSNavbar setActivePage={setActivePage} activePage={activePage} />
      <CMSBody activePage={activePage} />
    </div>
  );
};
export default CMS;
